// extracted by mini-css-extract-plugin
export default {"chatRoom":"Chat_chatRoom__H6uUQ","chatList":"Chat_chatList__vDFrp","chatForm":"Chat_chatForm__RNcvk"};